<ng-container>
    @if(isPageRestrictionLoaded){
        <div class="ppl-container-body">
        <div class="ppl-container-head" style="display: flex; gap: 12px; font-size: 1.7rem;">
        <h1 class="page-title-accessibility">Provider Interest</h1>
        <div class="action">
            @if(!isReadOnly){
            <ppl-button
            label="Create New Provider Interest"
            icon="fa fa-plus"
            [customClass]="'primary-button'"
            [iconPosition]="'left'"
            [authorizeButton]="[pageId, 'newProviderLead']"
            (click)="onNewLead()"
            ></ppl-button>
            }
        </div>
    </div>

    <div class="ppl-container">
        <div class="ppl-content-container">
            <div class="table-style">
    <!-- <div class="ppl-main-fullwidth"> -->
        <ppl-list-table [pageTitle]="'List of all Provider Interests'" [pageConfig]="programName"
            [sharedDataKey]="sharedDataKey" (rowDetailEvent)="rowClicked($event)" [loadPage]="lazyLoad"
            [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
            [enablePageActions]="true"
            [jsonList]="'list_providers_leads'"
            [badgeColumns]="['Application Status']"
            rowDataAccessibilityKey="lead_id" >
        </ppl-list-table>
    <!-- </div> -->
    </div>
    </div>
    </div>
    </div>
    }

</ng-container>